/**
 * Collection pagination:
 * - Default: append the next Shopify collection page to the grid.
 * - Contextual price sort (filters + price sort): append the next slice from the
 *   globally sorted in-memory list built by facets.js (no server re-sort).
 */

function appendProductGridItems({ sectionId, nextPage }) {
  const grid = document.querySelector('#product-grid');
  if (!grid) return;

  const button = document.querySelector(
    '.collection-load-more-button[data-section-id="' + sectionId + '"][data-current-page="' + (nextPage - 1) + '"]'
  );
  const loadButton =
    button || document.querySelector('.collection-load-more-button[data-section-id="' + sectionId + '"]');
  if (!loadButton) return;

  const totalPages = Number(loadButton.dataset.totalPages || 0);
  if (Number(nextPage) > totalPages && totalPages !== 0) return;

  const params = new URLSearchParams(window.location.search);
  params.set('section_id', sectionId);
  params.set('page', String(nextPage));

  const fetchUrl = `${window.location.pathname}?${params.toString()}`;

  loadButton.disabled = true;
  loadButton.classList.add('loading');

  return fetch(fetchUrl)
    .then((res) => res.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newLis = doc.querySelectorAll('#product-grid > li.grid__item');
      if (!newLis || newLis.length === 0) return;

      newLis.forEach((li) => grid.appendChild(li));

      const currentPage = Number(loadButton.dataset.currentPage || 1);
      const updatedPage = currentPage + 1;
      loadButton.dataset.currentPage = String(updatedPage);
      loadButton.disabled = false;
      loadButton.classList.remove('loading');

      if (
        updatedPage >= Number(loadButton.dataset.totalPages || 0) &&
        Number(loadButton.dataset.totalPages || 0) !== 0
      ) {
        loadButton.closest('.collection-load-more-wrapper')?.remove();
      }

      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger();
      }
    })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.error('Load more failed', err);
      loadButton.disabled = false;
      loadButton.classList.remove('loading');
    });
}

document.addEventListener('click', (event) => {
  const target = event.target.closest('.collection-load-more-button');
  if (!target) return;

  event.preventDefault();

  if (target.dataset.contextualSort === 'true') {
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.appendContextualPriceSortPage) {
      FacetFiltersForm.appendContextualPriceSortPage(target);
    }
    return;
  }

  const sectionId = target.dataset.sectionId;
  const currentPage = Number(target.dataset.currentPage || 1);
  const nextPage = currentPage + 1;

  appendProductGridItems({ sectionId, nextPage });
});
